/**
 * Wandelt ein UTC-Datum in ein deutsches Datum um.
 * @param utcDate - Das UTC-Datum.
 * @returns - Das deutsche Datum im Format "YYYY-MM-DD".
 */
export function convertUtcToGermanLocal(utcDate: Date, format = 'yyyy-MM-dd'): string {
    if (utcDate != null) {
        switch (format) {
            case 'DD.MM.YYYY':
                return utcDate.toLocaleDateString("de-DE")
                break
            default:
                return utcDate.toLocaleDateString("en-CA")
                break
        }
    } else {
        return ""
    }
}
/**
 * Gibt die Summe der Zeiten in einem Array von Zeit-Strings zurück.
 * (sumTimeStrings(["02:30", "01:45", "15:20"]) => "19:35")
 * @param times 
 * @returns 
 */
export function sumTimeStrings(times:string[]) {
    let totalMinutes = times.reduce((acc, time) => {
        const [hours, minutes] = time.split(':').map(Number);
        return acc + hours * 60 + minutes;
    }, 0);

    const totalHours = Math.floor(totalMinutes / 60);
    const remainingMinutes = totalMinutes % 60;

    return `${totalHours}:${remainingMinutes}`;
}
/**
 * 
 * @param serviceData 
 * @returns 
 */
export function getNormalizedService(serviceData: EmployServiceData): string {
    const service = serviceData.service
    const ekz = serviceData?.ekz || ""
    const ukz = serviceData?.ukz || ""
    const serviceInt = parseInt(service, 10)

    if (ekz.toLowerCase() === "dpfrü") {
        return "1";
    } else if (ekz.toLowerCase() === "dpmit") {
        return "2";
    } else if (ekz.toLowerCase() === "dpspä") {
        return "3";
    } else if (ekz.toLowerCase() === "dpne") {
        return "4";
    } else if (ekz.toLowerCase() === "dpget") {
        return "5";
    } else if (ukz.toLowerCase() === "u" && service === "9902") {
        return "11";
    } else if (ukz.toLowerCase() === "u" && service === "9900") {
        return "12";
    } else if (ukz.toLowerCase() === "fz" && service === "9900") {
        return "10,FZ";
    } else if (ekz.toLowerCase() === "10") {
        return "10";
    } else if (service === "9000") {
        return "10";
    } else if (service === "9900") {
        return "12";
    } else if (service === "9801") {
        return "*";
    } else if (service === "9802") {
        return "*";
    } else if (service === "9803") {
        return "*";
    } else if (service === "9902") {
        return "*";
    } else if (service === "6005") {
        return "1";
    } else if (service === "6006") {
        return "1";
    } else if (service === "6025") {
        return "2";
    } else if (service === "6026") {
        return "2";
    } else if (service === "6035") {
        return "3";
    } else if (service === "5080") {
        return "3";
    } else if (service === "5081") {
        return "3";
    } else if (service === "8602") {
        return "3";
    } else if (service === "8652") {
        return "3";
    } else if (service === "8654") {
        return "3";
    } else if (service === "4100") {
        return "1";
    } else if (service === "4300") {
        return "1";
    } else if (service === "4500") {
        return "1";
    } else if (service === "4101") {
        return "1";
    } else if (service === "4301") {
        return "1";
    } else if (service === "4501") {
        return "1";
    } else if (service === "4200") {
        return "2";
    } else if (service === "4400") {
        return "2";
    } else if (service === "4600") {
        return "2";
    } else if (service === "4201") {
        return "2";
    } else if (service === "4401") {
        return "2";
    } else if (service === "4601") {
        return "2";
    } else if (service === "7100") {
        return "1";
    } else if (service === "7300") {
        return "1";
    } else if (service === "7500") {
        return "1";
    } else if (service === "7900") {
        return "1";
    } else if (service === "7101") {
        return "1";
    } else if (service === "7301") {
        return "1";
    } else if (service === "7501") {
        return "1";
    } else if (service === "7200") {
        return "2";
    } else if (service === "7400") {
        return "2";
    } else if (service === "7600") {
        return "2";
    } else if (service === "7201") {
        return "2";
    } else if (service === "7401") {
        return "2";
    } else if (service === "7601") {
        return "2";
    } else if (/^00\d{2}$/.test(service) || /^20\d{2}$/.test(service)) {
        return "1";
    } else if (/^02\d{2}$/.test(service) || /^22\d{2}$/.test(service)) {
        return "2";
    } else if ((serviceInt >= 300 && serviceInt <= 353) ||
        (serviceInt >= 2300 && serviceInt <= 2353) ||
        (serviceInt >= 3301 && serviceInt <= 3319)) {
        return "3";
    } else if ((serviceInt >= 354 && serviceInt <= 360) ||
        (serviceInt >= 2354 && serviceInt <= 2360) ||
        (serviceInt >= 3354 && serviceInt <= 3360)) {
        return "4";
    } else if (/^04\d{2}$/.test(service) || /^24\d{2}$/.test(service)) {
        return "5";
    } else {
        return ekz;
    }
/*    else if (ekz === "*") {
        return ekz;
    }*/
}
